import { Controller } from '@hotwired/stimulus'

// 記事（D-1 実データコラム）用の軽量チャートコントローラー。
// Chart.js は記事pack全体には同梱せず、この要素が接続されたときだけ
// 動的importでコード分割ロードする（他記事の高速要件を損なわない）。
//
// data-controller="article-chart"
// data-article-chart-type-value="bar"
// data-article-chart-data-value='{"labels":[...],"values":[...],"label":"...","colors":[...]}'
export default class extends Controller {
  static targets = ['canvas']

  static values = {
    type: { type: String, default: 'bar' },
    data: Object
  }

  async connect() {
    const data = this.dataValue
    if (!data || !Array.isArray(data.labels) || data.labels.length === 0) return

    const { default: Chart } = await import('chart.js/auto')
    // 接続が切れた後にimportが解決したケースを無視（Turbolinks遷移対策）
    if (!this.element.isConnected) return

    this.chart = new Chart(this.canvasTarget, this.config(Chart, data))
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  config(_chart, data) {
    const brand = '#0d9488'
    const colors = data.colors && data.colors.length ? data.colors : brand

    return {
      type: this.typeValue,
      data: {
        labels: data.labels,
        datasets: [{
          label: data.label || '',
          data: data.values,
          backgroundColor: colors,
          borderRadius: 6,
          maxBarThickness: 56
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: '#1e293b',
            padding: 10,
            cornerRadius: 8,
            displayColors: false
          }
        },
        scales: {
          x: { grid: { display: false }, ticks: { font: { size: 11 } } },
          y: {
            beginAtZero: true,
            grid: { color: '#f1f5f9', drawTicks: false },
            border: { display: false },
            ticks: { font: { size: 11 }, callback: (value) => value.toLocaleString() }
          }
        }
      }
    }
  }
}
